export default{
  1 :	'ghost_mansion',
  2 :	'FuMei',
  100 :	'Battle_of_Trojan',
  200 :	'Enchanted_Gemstone',
  300 :	'Old_Down_Town',
  400 :	'ManOfSteel',
  500 :	'Royal_Jester',
  501 :	'In_the_Shell',
  502 :	'The_Giant_Shark',
  600 :	'Easter_Bonanza',
  700 :	'God_Of_The_Sun',
  800 :	'rolling_in_Gold',
  801 :	'The_Pig_Father',
  802 :	'Brideofthedead',
  803 :	'ChilliFire',
  900 :	'MagicLake',
  1000 :	'Rage_Of_Zeus',
  1100 :	'Tiki_Twilight',
  1200 :	'Mystic_Treasure',
  1300 :	'Jungle',
  1400 :	'Venus',
  1500 :	'LastDetective',
  1501 :	'FortunePop',
  1600 :	'SpookyBuddies',
  1601 :	'BunnyMoney',
  1700 :	'SpiritOfTheLamp',
  1701 :	'OktoberfestHaus',
  1702 :	'FortuneofCaiShen',
  1702 :	'GreatCaiShen',
  1703 :	'TheoryofLove',
  1704 :	'BlazeOfFortune',
  1800 :	"DragonsSister",
  1900 :	'WildWolf',
  1901 :	'MasterofTrident',
  2000 :	'Phoenix',
  2100 :	'RiseofTriumph',
  2101 :	'KingofArtic',
  2200 :	'Pharaoh_Revenants',
  2201 :	'TheWondersOfOz',
  2300 :	'Vampire_Rose',
  2301 :	'BlazingFox',
  2302 :	'TheShieldofLagertha',
  2303 :	'NinjaEvolution',
  2304 :	'Vigorousbull',
  2400 :	'Ruby_Heart',
  2401 :	'ImperialDiamond',
  2500 :	"TheKingHand",
  2501 :	'SherlockColdCase',
  2502 :	'ValkyriesBlessing',
  2601 :	'Mafia',
  2700 :	'FuDaoWealth',
  2701 :	'GenieintheLamp',
  2702 :	'EnchantingWishes',
  2800 :	'Lucky Magic Spin',
  2900 :	'DragonPhoenix',
  3000 :	'DoubleBonus',
  3100 :	'TombstoneMarshals',
  3101 :	'KittyLucie',
  3102 :	"The_Frog_Clovers",
  3103 :	'Legendary_Pandarcher',
  3104 :	'CityofLights',
  3105 :	'GoblinSquad',
  3106 :	'FreakyPhysicist',
  3107 :	'FlamingHuufbeats',
  3108 :	'ValentineWilds',
  3201 :	'The_White_Muse',
  3202 :	'EternalDragons',
  3300 :	'RedRidingHood',
  3301 :	'PrincessofPersia',
  3302 :	"Nutcrackers_Coins",
  3303 :	'JollyLolly',
  3400 :	'CleopetraQueenofSands',
  3401 :	'Hooksvoyage',
  3402 :	'PawsomePuppies',
  3500 :	'WildValley',
  3600 :	'JuicyReels',
  3700 :	'SpringTails',
  3800 :	'TigerClashCash',
  3900 :	'NeonLights',
  4000 :	'DrMonkeyLab',
  4100 :	'WesternGals',
  4101 :	'PyramidKitty',
  4102 :	'EpicThaiParadise',
  4200 :	'MermaidMystic',
  4201 :	'QueenofIndia',
  4202 :	'EpicJinQianWa',
  4300 :	'AnimalFarm',
  4400 :	'GlitzGlamour',
  4500 :	'TheGreatMonkey',
  4600 :	'ManofSteel7',
  4601 :	'TheDivineFour',
  4700 :	'TheSecretofAliBaba',
  4800 :	'GoalChampions',
  4900 :	'GoldenChip',
  5000 :	'GoldenBonsai',
  5100 :	'PiggyBankFever',
  5200 :	'ClassyBells',
  5300 :	'fortune_dice',
  5300 :	'TwicetheDice',
  5400 :	'GreenLantern',
  5500 :	'JusticeLeague',
  5600 :	'Mulan',
  5700 :	'AvengersEndgame',
  5800 :	'FishingTrip',
  6000 :	'EpicMusic',
  6100 :	'JurassicWorld',
  6200 :	'Joker',
  6300 :	'SpiderManFarFromHome',
  6400 :	'LotusBeauty',
  6500 :	'FuQiDuoDuo',
  6501 :	'YearoftheOx',
  6600 :	'MaidenLotus',
  6700 :	'BlackWidow',
  6800 :	'ForbiddenRelic',
  6900 :	'WonderWoman1984',
  7100 :	'RhinoRage',
  7200 :	'NianShou',
  7300 :	'DragonSaga',
  7400 :	'WukongBlessing',
  7500 :	'StarWarsTheForceAwaken',
  7700 :	'EpicHighwayKing',
  7801 :	'KingofVape',
  7900 :	'AICity',
  8000 :	'BearSeason',
  8100 :	'CaptainMarvel',
  8200 :	'EpicPantherMoon',
  8201 :	'EpicSafariHeat',
  8400 :	'LunarNewYear',
  8500 :	'EpicIrishLuck',
  8600 :	'EpicGreatBlue',
  8800 :	'GodzillaVSKong',
  9100 :	'Venom2',
  9200 :	'TomJerry',
  9300 :	'FootballStriker',
  9400 :	'Wonder Wheel',
  9401 :	'Demond and Angel',
  9500 :	'Hot Kick',
  10300 :	'HocusFrogus',
  10400 : 'fishingwar',
  10500 : 'rockpaperscissor',
  11000 :	'GreatAthletes',
  12000 :	'TheSuicideSquad',
  820001 :	'Baccarat',
  820003 :	'Thai Hi Lo',
  820004 :	'Dragon Tiger',
  820005 :	'Xoc Dia',
  820006 :	'Bullfight',
  820007 :	'Crab and Shrimp',
  821001 :	'car_racing',
  821002 :	'fantasy_forest',
  821003 :	'fowl_beast',
  821004 :	'Songkran Fowl and Beast',
  821005 :	'final_30s',
  821006 :	'soccer_mania',
  821007 :	'raya_fortune',
  821008 :	'angpao_rain',
  821012 :	'husky_poker',
  821013 :	'Go Go Monkey',
  821014 :	'temple_of_monkey',
  821015 :	'master_thief',
  821016 :	'prophecy_mage',
  821018 :	'over_under',
  821020 :	'cock_fighting',
  821021 :	'pikachu',
  821022 :	'despicable_me3',
  821023 :	'rock_paper_scissors',
  821024 :	'lucky_777',
  821025 :	'In Between',
  821026 :	'Panda Fruit Machine',
  821027 :	'Mario Ace',
  821028 :	'Forest Party',
  821029 :	'Golden Flower',
  821030 :	'Hundred San Gong',
  821031 :	'Mini Roulette',
  821032 :	'Sic Bo',
  821033 :	'Motorbike',
  821034 :	'Hundred Poker',
  821035 :	'In Between Poker',
  821036 :	'Domino QQ',
  821037 :	'Domino Ceme',
  821038 :	'Mini Sic Bo',
  821039 :	'Single Poker',
  821041 :	'Fortune Ox',
  830001 :	'ocean_king2',
  830002 :	'ocean_dragon',
  830003 :	'ocean_king3',
  830004 :	'golden_toad',
  830005 :	'dasheng_naohai',
  830006 :	'likui_piyu',
  830007 :	'yaoqian_shu',
  830008 :	'hai_ba',
  830009 :	'caishen_fishing',
  830010 :	'Fishing War',
  830011 :	'Monkey King',
  830012 :	'Ocean King 4',
  830013 :	'Happy Fish',
  830015 :	'God Defense',
  840001 : 	'GatesofOlympus',
  840002 : 	'SweetBonanza',
  840003 : 	'BonanzaGold',
  840004 : 	'GreatRhinoMegaways',
  840005 : 	'5LionsMegaways',
  840006 : 	'ChristmasCarolMegaways',
  840007 : 	'MadameDestinyMegaways',
  840008 : 	'AztecBonanza',
  840009 : 	'Starlight Princess',
  840010 : 	'Yum Yum Powerways',
  840011 : 	'888 Dragons',
  840012 : 	'The Magic Cauldron',
  840013 : 	'Sweet Bonanza Xmas',
  840014 : 	'Drago – Jewels of Fortune',
  840015 : 	'Fruit Party',
  840016 : 	'Aztec Gems',
  840017 : 	'Fruit Party 2',
  840018 : 	'Big Bass Bonanza',
  840019 : 	'The Dog House Megaways',
  840020 : 	'BuffaloKingMegaways',
  840021 : 	'Curse of the Werewolf Megaways',
  840022 : 	'Starz Megaways',
  840023 : 	'GemsBonanza',
  840024 : 	'Power of Thor Megaways',
  840025 : 	'Chilli Heat Megaways',
  840026 : 	'5 Lions Gold',
  840027 : 	'5 Lions',
  840028 : 	"Caishen's Cash",
  840029 : 	'Fire Strike',
  840030 : 	'John Hunter and the Tomb of the Scarab Queen',
  850001 :  'goldencolt',
  850002 :  'legendofwhitesnakelady',
  850003 :  'desertgem',
  850004 :  'matsuri',
  850005 :  'golden',
  850006 :  'blazeofra',
  850007 :  'masquerade',
  850008 :  'zombiecircus',
  850009 :  'houseofdoom',
  850010 :  'darkvortex'
}